(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let header = document.querySelector('.shopify-section.section-header gaia-header');
    let menuPadYSm = getComputedStyle(document.documentElement).getPropertyValue('--menu-pad-y-sm').trim();
    let menuPadYSmValue = parseInt(menuPadYSm) || 0;

    document.documentElement.style.setProperty(
      '--header-height',
      `${parseInt(header.getBoundingClientRect().height) + 2 * menuPadYSmValue}px`
    );

    // console.log('Header height set to', document.documentElement.style.getPropertyValue('--header-height'));

    var headerObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const cr = entry.contentRect;
        document.documentElement.style.setProperty('--header-height', `${parseInt(cr.height) + 2 * menuPadYSmValue}px`);
      }
    });

    // Observe one or multiple elements
    headerObserver.observe(header);

    const mobileMenuDetails = document.querySelector('gaia-mobile-menu details');

    if (mobileMenuDetails) {
      mobileMenuDetails.addEventListener('toggle', (event) => {
        const summary = event.target.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', event.target.open);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
